module.exports = __webpack_public_path__ + "img/nexultraLHorizontal.896cdee7.jpg";